import { useMemo } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { ADMIN_PAGES, type AdminPage } from './adminPages';
import { AppShell } from './AppShell';
import { buildNavItems } from './navItems';

export const AppLayout = ({ adminPages = ADMIN_PAGES }: { adminPages?: readonly AdminPage[] }) => {
  const { can } = useAuth();
  const items = useMemo(() => buildNavItems(can, adminPages), [can, adminPages]);
  return <AppShell items={items} />;
};
